import { BatchedMesh, type BufferGeometry, type Material } from 'three';
import type { LifeRoute } from './types';

interface BodyGroup {
  readonly geometry: BufferGeometry;
  readonly routes: readonly LifeRoute[];
}

/** Different bodies share one multi-draw batch; each template is stored once and each actor moves. */
export function batchBodies(groups: readonly BodyGroup[], material: Material) {
  const routes = groups.flatMap((group) => group.routes);
  const batch = new BatchedMesh(
    routes.length,
    groups.reduce((n, g) => n + g.geometry.getAttribute('position').count, 0),
    groups.reduce((n, g) => n + g.geometry.index!.count, 0),
    material
  );
  batch.name = 'life-cast-body';
  batch.frustumCulled = false;
  batch.perObjectFrustumCulled = false;
  batch.sortObjects = false;
  for (const group of groups) {
    // These temporary body templates are discarded after copying into the batch.
    const geometry = group.geometry;
    geometry.deleteAttribute('aInstanceEdgeId');
    geometry.deleteAttribute('aPainterScale');
    const geometryId = batch.addGeometry(geometry);
    group.routes.forEach(() => batch.addInstance(geometryId));
  }
  batch.userData['lifeRoutes'] = routes;
  return { mesh: batch, routes };
}
